// @flow
/**
 * List of queries allowed when performing a search or deeplinking
 * @type {Object}
 * @private
 */
const queries = {
  domain: String,
  ondemand: Boolean,
  currency: String,
  trip_id: String,
  session_id: String,
  mode: String,
  include_platform_fee: Boolean,
  include_target_pricing: Boolean,
  hourly_booking_duration: Number,
  num_passengers: Number,
  start_address: String,
  end_address: String,
  start_location: String,
  end_location: String,
  start_id: String,
  end_id: String,
  start_lat: String,
  start_lng: String,
  end_lat: String,
  end_lng: String,
  start_terminal: String,
  end_terminal: String,
  start_name: String,
  end_name: String,
  flight_datetime: String,
  pickup_datetime: String,
  return_flight_datetime: String,
  return_pickup_datetime: String,
  customer_special_instructions: String,
  flight_type: String,
  sources: String,
  types: String,
  ref: String,
  referral: String,
  campaign: String,
  utm_campaign: String,
  branch: String,
  loyaly: String,
  customer_id: String,
  dir: String,
  airline: String,
  flight_number: String,
  airline2: String,
  flight_number2: String,
  first_name: String,
  last_name: String,
  email: String,
  dial_code: String,
  phone_number: String,
  provider: String,
  ta: String,
  de_wl: String,
  de_bl: String,
  data_entry_wl: String,
  data_entry_bl: String,
  marketing: Object,
  corporate_trip_id: String,
  pnr: String,
  client_address: String,
  polling_limit: Number,
  use_cached_search: Boolean,
  ticket_types: Array,
  pass_types: Array,
  corp_id_list: Array,
  coupon_code: String,
  start_is_hotel: Boolean,
  end_is_hotel: Boolean,
  include_alerts: Boolean,
  go_corp_id: String,
}

export default queries
